import React from 'react';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { useStore } from 'Hooks/useStore';
import './SheerIdBanner.css';

const title = 'ONE YEAR FREE for Military, Veterans and First Responders';
const ctaText = 'Unlock Offer';

export const SheerIdBanner = () => {
  const { sheerIdUrl } = useStore('appConfig.defaultConfig');

  const handleClick = () => {
    const pageTraits = {
      page_item_title: title,
      page_button_text: ctaText,
      page_action_location: 'title',
      page_collection_title: 'no collection title',
    };
    trackEvent(TRACKING_ENUMS.EVENT_BANNER_CLICKED, pageTraits);
  };

  return (
    <div className="sheerIdPromoBanner">
      <div className="sheerIdBannerContainer">
        {/* mobile */}
        <a onClick={() => handleClick()} className="bannerContainerMobile" href={sheerIdUrl}>
          <div className="bannerTitle">{title}</div>
          <img
            className="bannerArrow"
            src="/account/static/images/chevron-grey.svg"
            width="24"
            height="24"
            alt="arrow"
          />
        </a>
        {/* desktop */}
        <div className="bannerContainer">
          <div className="bannerTitle">{title}</div>
          <a onClick={() => handleClick()} className="bannerLink" href={sheerIdUrl}>
            {ctaText}
          </a>
        </div>
      </div>
    </div>
  );
};
